import {createSelector} from 'reselect';
import {getIsCardExpiryDateWave2Experiment, getIsInCombinedUXExperiment} from './ExperimentSelectors';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings, getIsCardExpiryDateWave2Experiment, getIsInCombinedUXExperiment],
  (settings, isCardExpiryDateWave2Experiment, isCombinedUXExperiment) => (
    !!settings.enable_expiry_date_wave_2
      || isCardExpiryDateWave2Experiment
      || isCombinedUXExperiment
  ),
);
